<div class="overlay">
  <div class="modal" style="width: 100%; height: 100%">
    <div class="modal-content">
      <div class="flex justify-content-between flex-wrap" style="
    padding-top: 15px;
    padding-bottom: 16px;
    padding-right: 2px;
    padding-left: 70px;
    border-bottom: 1px solid #f2f4f7;
  ">
        <div class="img">
          <div class="flex justify-content-start flex-wrap">
            <div class="flex align-items-center justify-content-center mr-1">
              <img src="assets/image/auto-e-care-logo.png" alt="Logo" class="svg-black" />
            </div>
            <!-- <div class="flex align-items-center justify-content-center">
              <p style="color: #1d2939; font-weight: 700; font-size: 18px">
                Auto ECare
              </p>
            </div> -->
          </div>
        </div>
        <!-- <div class="flex align-items-center justify-content-center">
          <p style="font-weight: 700; color: #333; font-size: 24px;">
            {{ editMode ? 'Add Service Provider Form' : 'Update Service Provider Form' }}
          </p>
        </div> -->
        <div class="flex justify-content-center flex-wrap align-items-center">
          <div class=" cross-icon">
            <i class="pi pi-times" style="cursor: pointer; font-size: 1em; top: 0;" (click)="close()"></i>
          </div>
        </div>
      </div>

      <div class="flex" style="height: calc(100vh - 70px); ">
        <div class="sidebar" style="margin-top: 62px">
          <ul>
            <li>
              <a (click)="setActiveSection('map-location')" [ngClass]="{
                  active: activeSection === 'map-location'
                }">
                <i class="pi pi-map-marker"></i>Location
              </a>
            </li>
            <li>
              <a (click)="setActiveSection('address-proof')" [ngClass]="{ active: activeSection === 'address-proof' }">
                <i class="pi pi-file-plus"></i>Address-Proof
              </a>
            </li>
            <li>
              <a (click)="setActiveSection('business-details')"
                [ngClass]="{ active: activeSection === 'business-details' }">
                <i class="pi pi-bars"></i> Business Details
              </a>
            </li>
            <li>
              <a (click)="setActiveSection('owner-details')" [ngClass]="{ active: activeSection === 'owner-details' }">
                <i class="pi pi-user"></i> Owner/Incharge Details
              </a>
            </li>
            <li>
              <a (click)="setActiveSection('service-offered')"
                [ngClass]="{ active: activeSection === 'service-offered' }">
                <i class="pi pi-wrench"></i> Service Offered
              </a>
            </li>
            <li>
              <a (click)="setActiveSection('brands')" [ngClass]="{ active: activeSection === 'brands' }">
                <i class="pi pi-users"></i> Brand Details
              </a>
            </li>
            <li>
              <a (click)="setActiveSection('technician-details')"
                [ngClass]="{ active: activeSection === 'technician-details' }">
                <i class="pi pi-users"></i> Technician Details
              </a>
            </li>
          </ul>

        </div>
        <div class="content" style="flex-grow: 1;" [ngClass]="{'no-scroll': activeSection === 'map-location'}">

          <app-map-location *ngIf="activeSection ==='map-location'" (nextSection)="setActiveSection('address-proof')"
            [formSource]="'Service-Provider'" [formStateService]="spFormstate"></app-map-location>

          <app-addressproof *ngIf="activeSection === 'address-proof'"
            (nextSection)="setActiveSection('business-details')" [formSource]="'Service-Provider'"
            [formStateService]="spFormstate"></app-addressproof>

          <app-business-details-new *ngIf="activeSection === 'business-details'"
            (nextSection)="setActiveSection('owner-details')"></app-business-details-new>

          <app-incharge-owner-details *ngIf="activeSection === 'owner-details'" [countryId]="countryId"
            (nextSection)="setActiveSection('service-offered')"></app-incharge-owner-details>

          <app-service-offered-new *ngIf="activeSection === 'service-offered'"
            (nextSection)="setActiveSection('brands')"></app-service-offered-new>
          <app-brand-details *ngIf="activeSection==='brands'"
            (nextSection)="setActiveSection('technician-details')"></app-brand-details>
          <app-technician-info *ngIf="activeSection === 'technician-details'"
            (updateServiceProviderList)="onUpdateProviderList()" (close)="close()"></app-technician-info>

        </div>
      </div>
    </div>
  </div>
</div>